import * as React from "react";
import { groupContext } from "../index.js";
import ChoosePayment from "../choosePayment/choosePayment.js";
import { OneTimeOfferOrderingContainer } from "../oneTimeOfferOrderingContainer/oneTimeOfferOrderingContainer.js";
import "./style.css";
export function OneTImeOfferBeforePaymentContainer(props) {
    var _a, _b, _c;
    const group = React.useContext(groupContext);
    const [currentOfferIndex, setCurrentOffer] = React.useState(0);
    const [methodOpen, setMethodOpen] = React.useState(false);
    const oneTimeOffers = group.categories.flatMap((category) => category.offers.filter((offer) => offer.forEveryImage === false && offer.isBeforePayment == true));
    const currentOffer = oneTimeOffers[currentOfferIndex];
    if (methodOpen === false &&
        props.orderedOffers.some((offer) => offer.name === (currentOffer === null || currentOffer === void 0 ? void 0 : currentOffer.name))) {
        setMethodOpen(true);
    }
    if (!currentOffer && methodOpen === false) {
        setMethodOpen(true);
    }
    return (React.createElement("div", { className: "after-bucket-menu-container" },
        !methodOpen && (React.createElement("div", null,
            React.createElement(OneTimeOfferOrderingContainer, { categoryIndex: group.categories.findIndex((c) => c.offers.some((offer) => (offer === null || offer === void 0 ? void 0 : offer.name) === (currentOffer === null || currentOffer === void 0 ? void 0 : currentOffer.name))), offer: currentOffer, onExit: () => {
                    props.onUpdateBucket();
                    if (currentOfferIndex >= oneTimeOffers.length - 1) {
                        setMethodOpen(true);
                        return;
                    }
                    setCurrentOffer((old) => old + 1);
                } }))),
        methodOpen && (React.createElement(ChoosePayment, { ...props, flow: (_a = group === null || group === void 0 ? void 0 : group.flow) === null || _a === void 0 ? void 0 : _a.onOrderSubmit, componentsList: (_b = group === null || group === void 0 ? void 0 : group.flow) === null || _b === void 0 ? void 0 : _b.componentsList, payment: group === null || group === void 0 ? void 0 : group.payment, shipping: group === null || group === void 0 ? void 0 : group.shipping, inpostGeowidgetToken: group === null || group === void 0 ? void 0 : group.inpostGeowidgetToken, infoBeforePayment: (_c = group === null || group === void 0 ? void 0 : group.content) === null || _c === void 0 ? void 0 : _c.infoBeforePayment }))));
}
